import {
  BasicButton,
  ButtonGroup,
  Grid,
  GridItem,
  Text,
  Illustration,
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  PrimaryButton,
} from "@certn/cascadia-react";
import { showPendoGuideById } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type SubmitCheckModalProps = {
  show: boolean;
  provideFeedback: boolean;
  setShowSuccessModal: any;
};

export function SubmitCheckModal({
  show,
  provideFeedback,
  setShowSuccessModal,
}: SubmitCheckModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!show) {
    return null;
  }

  const handleClose = () => {
    setShowSuccessModal(false);
    navigate(".", { state: {}, replace: true });
    showPendoGuideById("x__BnAF6q1Q98wrpAFrZe8AtUK4");
  };

  return (
    <Modal isOpen={show}>
      <Dialog width="456px">
        {({ close }) => (
          <>
            <DialogHeader onClose={handleClose}>
              {t("Background check submitted")}
            </DialogHeader>
            <DialogContent>
              <Grid>
                <GridItem>
                  <Illustration name="success" />
                </GridItem>
                <GridItem>
                  <Text style="global/body-primary">
                    <Trans>
                      Your background check information has been submitted, and
                      you can track your progress in the history section of your
                      dashboard.
                    </Trans>
                  </Text>
                  {provideFeedback && (
                    <Text style="global/body-primary">
                      <Trans>
                        <br />
                        If you have two minutes to spare, we’d love to hear how
                        we can improve your experience.
                      </Trans>
                    </Text>
                  )}
                </GridItem>
              </Grid>
            </DialogContent>
            <DialogFooter>
              <ButtonGroup>
                {provideFeedback && (
                  <BasicButton size="medium">
                    <Trans>Provide feedback</Trans>
                  </BasicButton>
                )}
                <PrimaryButton
                  type="submit"
                  size="medium"
                  onPress={handleClose}
                  testID="submit-application-modal-close-button"
                >
                  <Trans>Close</Trans>
                </PrimaryButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
